export default {
  WEEK: 1,
  MONTH: 2
};
